import { readRemaininghtnrfi4c8vp0 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_save__qhzefp(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var tmp = readRemaining(_this__u8e3s4.d5g().o5i(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var responseBody = readByteArray(tmp);
  return SavedHttpCall().x5j(_this__u8e3s4.y5f_1, _this__u8e3s4.z5h(), _this__u8e3s4.d5g(), responseBody);
}
function save(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, _this__u8e3s4), $completion);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static x5j(client, request, response, responseBody) {
        var $this = this.y5h(client);
        $this.v5j_1 = responseBody;
        $this.a5g_1 = new (SavedHttpRequest())($this, request);
        $this.b5g_1 = new (SavedHttpResponse())($this, $this.v5j_1, response);
        checkContentLength(contentLength(response), fromInt($this.v5j_1.length), request.h5i());
        $this.w5j_1 = true;
        return $this;
      }
      b5i() {
        return this.w5j_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.y5j_1 = origin;
        this.z5j_1 = call;
      }
      g5i() {
        return this.z5j_1;
      }
      ew() {
        return this.y5j_1.ew();
      }
      h5i() {
        return this.y5j_1.h5i();
      }
      i5i() {
        return this.y5j_1.i5i();
      }
      a5i() {
        return this.y5j_1.a5i();
      }
      i2o() {
        return this.y5j_1.i2o();
      }
      a50() {
        return this.y5j_1.a50();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.a5k_1 = call;
        this.b5k_1 = body;
        this.c5k_1 = origin.p5i();
        this.d5k_1 = origin.q5i();
        this.e5k_1 = origin.r5i();
        this.f5k_1 = origin.s5i();
        this.g5k_1 = origin.a50();
        this.h5k_1 = origin.ew();
      }
      g5i() {
        return this.a5k_1;
      }
      p5i() {
        return this.c5k_1;
      }
      q5i() {
        return this.d5k_1;
      }
      r5i() {
        return this.e5k_1;
      }
      s5i() {
        return this.f5k_1;
      }
      a50() {
        return this.g5k_1;
      }
      ew() {
        return this.h5k_1;
      }
      o5i() {
        return ByteReadChannel(this.b5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save2n0hem2ixzltm,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
